var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-card",class:_vm.colorClass},[_c('div',{staticClass:"sidebar-card__header"},[_vm._t("header")],2),_c('div',{staticClass:"sidebar-card__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }